import { createAction, props } from '@ngrx/store';
import { IAsqFundItem } from '../models/asq-funds.model';

export const loadAsqFunds = createAction('[ASQ Funds] Load ASQ Funds');

export const loadAsqFundsSuccess = createAction(
  '[ASQ Funds] Load ASQ Funds Success',
  props<{ response: IAsqFundItem[] }>()
);

export const loadAsqFundsFailure = createAction(
  '[ASQ Funds] Load ASQ Funds Failure',
  props<{ error: Error | any }>()
);
